module.exports = __webpack_public_path__ + "static/media/activity-content-one.9ab0eca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/activity/components/images/activity-content-one.png
// module id = 904
// module chunks = 0